export class AppPathConsts {
    static readonly Prefix = 'app/main/';
    static readonly ConfigurationPrefix = AppPathConsts.Prefix + 'configurations';
    static readonly TemplatePrefix = AppPathConsts.Prefix + 'templates';
    static readonly EvaluationPrefix = AppPathConsts.Prefix + 'evaluations';
    static readonly CalibrationPrefix = AppPathConsts.Prefix + 'calibrations';
    static readonly ReportPrefix = AppPathConsts.Prefix + 'reports';
    static readonly OperatorsPrefix = AppPathConsts.Prefix + 'operators';
    static readonly OperatorEvaluationSummariesPrefix = AppPathConsts.Prefix + 'operator-evaluation-summaries';

    static readonly Create = 'create';
    static readonly Update = 'update/';

    static readonly RolePlaces = 'role-places';
    static readonly RolePlacesUpdate = this.RolePlaces + '/update/';

    static readonly InformationSources = 'information-sources';
    static readonly InformationSourcesCreate = this.InformationSources + '/create';
    static readonly InformationSourcesUpdate = this.InformationSources + '/update/';

    static readonly Places = 'places';
    static readonly PlacesCreate = this.Places + '/create';
    static readonly PlacesUpdate = this.Places + '/update/';

    static readonly Shifts = 'shifts';
    static readonly ShiftsCreate = this.Shifts + '/create';
    static readonly ShiftsUpdate = this.Shifts + '/update/';

    static readonly AnswerGroups = 'answer-groups';
    static readonly AnswerGroupsCreate = this.AnswerGroups + '/create';
    static readonly AnswerGroupsUpdate = this.AnswerGroups + '/update/';

    static readonly QuestionGroups = 'question-groups';
    static readonly QuestionGroupsCreate = this.QuestionGroups + '/create';
    static readonly QuestionGroupsUpdate = this.QuestionGroups + '/update/';

    static readonly Questions = 'questions';
    static readonly QuestionsCreate = this.Questions + '/create';
    static readonly QuestionsUpdate = this.Questions + '/update/';

    static readonly OperatorsCreate = this.OperatorsPrefix + '/create';
    static readonly OperatorsUpdate = this.OperatorsPrefix + '/update/';

    static readonly TemplatesCreate = this.TemplatePrefix + '/create';
    static readonly TemplatesUpdate = this.TemplatePrefix + '/update/';

    static readonly Calibrations = 'calibrations';

    static readonly ExportResults = 'export-results';
    static readonly ExportSelfEvaluations = 'export-self-evaluations';

    static readonly OperatorEvaluationSummariesDetail = 'detail/';
}
